import { create, StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';

export type CashRegisterStoreType = {
  isOpen: boolean;
  loading: boolean;
  box: any;
  initial: VoidFunction;
  create: (box: any) => void;
  activateLoading: VoidFunction;
};
export interface CashRegisterContextType extends CashRegisterStoreType {
  createCashRegister: (values: unknown) => void;
  closeCashRegister: (values: Record<string, unknown>) => void;
  refetch: VoidFunction;
}

const createCashRegisterStore: StateCreator<CashRegisterStoreType> = (set, get) => ({
  isOpen: false,
  box: null,
  loading: true,
  initial: () => {
    set(() => ({
      isOpen: false,
      box: null,
      loading: false,
    }));
  },
  create: (box: any) => {
    if (box?.id) {
      set(() => ({
        isOpen: true,
        box,
        loading: false,
      }));
    } else {
      set(() => ({
        isOpen: false,
        box: null,
        loading: false,
      }));
    }
  },
  activateLoading: () => {
    set(() => ({
      loading: !get().loading,
    }));
  },
});

export const CashRegisterStore = create<CashRegisterStoreType>()(devtools(createCashRegisterStore));
